


























































































































































































import { defineComponent, ref, Ref, toRefs, computed, watch, reactive, getCurrentInstance } from '@vue/composition-api';
import { TreeNodeValue, TreeNodeModel } from 'tdesign-vue';
import {
  SearchIcon,
  UserIcon,
  CaretRightSmallIcon,
  LoadingIcon,
  CaretDownSmallIcon,
  UsergroupIcon,
} from 'tdesign-icons-vue';

// 引入 compositions
import { showPhoneOrAccountName } from '@/renderer/components/dialog/AddTransfer/compositions/useTools';
import useOrgTreeStructure from '@/renderer/components/dialog/AddTransfer/compositions/useOrgTreeStructure';
import actionHandler from '@/renderer/views/desktop/ManageConsole/UserManagement/innerUser/compositions/actionHandler';
import userListHandler from '@/renderer/views/desktop/ManageConsole/UserManagement/innerUser/compositions/listHandler';

// 引入工具类
import i18n, { i18n_t } from '@/locales/i18n';
import ipc from '@/renderer/scripts/utils/ipc';
import { SMH } from '@/renderer/scripts/smh';
import { checkRoleIsAdmin } from '@/renderer/scripts/utils/UserRole';
import HideableTooltip from './HideableTooltip.vue';
import DataTransferHelpDialog from './DataTransferHelpDialog.vue';

export default defineComponent({
  components: {
    SearchIcon,
    UserIcon,
    CaretRightSmallIcon,
    LoadingIcon,
    CaretDownSmallIcon,
    UsergroupIcon,
    HideableTooltip,
    DataTransferHelpDialog,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    // 是否有个人空间,默认有
    noPersonalSpace: {
      type: Boolean,
      default: false,
    },
    users: {
      type: Array,
      default: [],
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const transferItems = reactive({
      // transferAll: false,
      // 全选
      transferPersonalFiles: false,
      // 个人空间文件
      transferSendedFiles: false,
      // 发出的共享
      transferCreatedGroup: false, // 创建的协作群组
      transferJoinedGroup: false, // 加入的协作群组
      transferSendedLinks: false,
      // 发出的链接
      transferReceivedFiles: false, // 收到的共享
    });

    const needTransfer = computed(
      () =>
        transferItems.transferPersonalFiles ||
        transferItems.transferSendedFiles ||
        transferItems.transferCreatedGroup ||
        transferItems.transferJoinedGroup ||
        transferItems.transferSendedLinks ||
        transferItems.transferReceivedFiles,
    );

    const treeKeys = {
      value: 'id',
      // label: 'name',
      children: 'children',
    };
    const activedTreeNode: Ref<number[]> = ref([]);
    const activedTreeUserId: Ref<number> = ref(0); // 树列表里选中的user
    const activedListUserId: Ref<number> = ref(0); // 搜索列表里选中的user
    const nameSearch = ref('');
    const isSearched = ref(false); // 展示搜索结果
    const searchedList: Ref<SMH.UserBaseInfo[]> = ref([]);
    const showHelpDialog = ref(false);
    const errorTipsTimerId = ref<any>(null);

    const {
      teamData,
      hasMoreUser,
      loadLimit,
      loading: listLoading,
      methods: treeListMethods,
    } = useOrgTreeStructure({ showPhoneNumber: true });

    const {
      dataTransferErrorTips: errorTips,
      personalCapacity,
      createdGroupCapacity,
      deleteUsers,
      getUserCapacity,
    } = actionHandler();
    const { methods: userListMethods } = userListHandler();
    treeListMethods.initTeamTree();
    getUserCapacity(props.users);

    const methods = {
      // 树节点选中
      nodeActive(
        value: Array<TreeNodeValue>,
        context: {
          node: TreeNodeModel;
        },
      ) {
        const { node } = context;
        if (node.data.id === activedTreeNode.value[0]) return;
        // 选中团队
        if (!node.data.nickname) return;
        activedTreeNode.value = [node.value as number];
        activedTreeUserId.value = node.data.userId;
      },
      showHelp() {
        showHelpDialog.value = true;
      },
      showError(error: string) {
        if (error === '') {
          return;
        }
        if (errorTipsTimerId.value) {
          clearTimeout(errorTipsTimerId.value);
          errorTipsTimerId.value = 0;
        }
        errorTipsTimerId.value = setTimeout(() => {
          errorTips.value = '';
        }, 5000);
      },
      // 搜索用户
      async searchUser() {
        // 空搜回到树列表
        if (nameSearch.value === '') {
          isSearched.value = false;
          return;
        }
        isSearched.value = true;
        activedListUserId.value = 0;
        searchedList.value = await userListMethods.pullAllUserList({
          keyword: nameSearch.value,
          pageSize: 40,
        });
      },
      clearSearch() {
        nameSearch.value = '';
        searchedList.value = [];
        methods.searchUser();
      },
      // 确定
      async confirm() {
        if (!needTransfer.value) {
          errorTips.value = i18n_t('需要选择移交内容');
          return;
        }
        const distUserId = isSearched.value ? activedListUserId.value : activedTreeUserId.value;
        let transToSelf = false;
        for (let i = 0; i < props.users.length; i++) {
          const ele = props.users[i];
          if ((ele as any).id === distUserId) {
            transToSelf = true;
          }
        }
        if (transToSelf) {
          errorTips.value = i18n_t('不可移交给待删除用户');
          return;
        }
        if (!distUserId) {
          errorTips.value = i18n_t('需要选择接收成员');
          return;
        }
        const params = {
          dist_user_id: distUserId,
          move_space: Number(transferItems.transferPersonalFiles),
          move_share: Number(transferItems.transferSendedLinks),
          move_created_group_authorization: Number(transferItems.transferCreatedGroup),
          move_join_group_authorization: Number(transferItems.transferJoinedGroup),
          move_authorized: Number(transferItems.transferSendedFiles),
          move_received_authorization: Number(transferItems.transferReceivedFiles),
        };
        const isSuccessful = await deleteUsers(props.users, params);
        if (isSuccessful) {
          innerShow.value = false;
          ipc.emit(ipc.RENDERER_EVENTS_MAP.USER_INFO_CHANGE);
        }
      },
    };
    watch(
      () => errorTips.value,
      val => {
        methods.showError(val);
      },
    );

    watch(
      () => transferItems.transferPersonalFiles,
      val => {
        if (!val) {
          transferItems.transferSendedFiles = false;
        }
      },
    );

    return {
      innerShow,
      transferItems,
      needTransfer,
      treeKeys,
      listLoading,
      hasMoreUser,
      loadLimit,
      activedTreeNode,
      activedTreeUserId,
      activedListUserId,
      nameSearch,
      isSearched,
      searchedList,
      showHelpDialog,
      errorTips,
      personalCapacity,
      createdGroupCapacity,
      ...toRefs(teamData),
      showPhoneOrAccountName,
      ...methods,
      treeListMethods,
      checkRoleIsAdmin,
    };
  },
});
